<script>
    import Router from 'svelte-spa-router';
    import Home from './routes/Home.svelte';
    import Adventure from './routes/Adventure.svelte';
    import NotFound from './routes/NotFound.svelte';

    const routes = {
        '/': Home,
        '/home': Home, 
        '/adventure': Adventure,
        '*': NotFound
    };
</script>

<main>
    <Router {routes} />
</main>

<style>
    main {
        padding: 1em;
        max-width: 800px;
        margin: 0 auto;
    }
</style>